import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';
import QrWidget from '../vendor/qrcode/qrcode.js';

/**
 * Generates and displays a QR Code for EasyPoint pickup.
 *
 * https://www.swisscom.ch/easypoint/?9-5-38297179610 redirects to
 * https://www.swisscom.ch/en/residential/easypoint.html#9-5-38297179610
 *
 * - The number before the first dash (e.g. `9-`) selects the prefix
 * - The suffix is the rest of the URL fragment identifier: 5-38297179610
 * - The actual values for the prefixes are configured in the component
 *
 * @author Cesar Keller, Marcel Greter
 * @class EasyPointQrCode
 * @extends Tc.Module
 */
export default class EasyPointQrCode extends Module {

	/**
	 * Hook function to do all of your module stuff.
	 *
	 * @method on
	 * @return void
	 */
	public on(callback : Hook) {

		const hash = location.hash ? location.hash.replace(/^#/, '') : '';

		// Split into two parts at first dash
		const dashPos = hash.indexOf('-');
		const select = hash.substr(0, dashPos);
		const suffix = hash.substr(dashPos + 1);

		// Get configured prefixes from data attribute
		const prefixes = this.$ctx.data('prefixes');

		if (prefixes === undefined) {

			this.log.error('No QR code prefixes found');

		} else if (!select || !suffix) {

			this.log.error('Invalid QR code parameter');

		} else if (prefixes[select] === undefined || prefixes[select] === '') {

			this.log.error('Unknown QR code prefix');

		} else {

			// Concat static prefix and custom suffix
			const code = prefixes[select] + suffix;

			// Draw QrCode into module space
			const qr = new QrWidget(
				this.$ctx[0], {
					height: 512,
					text: code,
					useSVG: navigator.userAgent.indexOf('SamsungBrowser') === -1,
					width: 512,
			});

			this.log('Rendered QR code ', code, ' into ', qr);

		}

		callback();
	}

}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/widget/Tc.Module.EasyPointQrCode.ts